<template>
    <a-spin :spinning="tableRelevant.tableLoading" id="StepsSecond">
        <div class="left hideScroll">
            <a-tree :checkedKeys="tree.checkedKeys"
                    checkable
                    checkStrictly
                    @check="treeCheck"
                    @select="treeCheck"
                    :replaceFields="{title:'name', key:'id'}"
                    :tree-data="tree.treeData">
                    <span slot="title" slot-scope="value">
                        {{value.name}}
                        （{{value.selectStuNum + value.add.length - value.del.length}}
                        / {{value.userCount}}）
                    </span>
            </a-tree>
        </div>
        <div class="right hideScroll">
            <a-form-model layout="inline" :model="searchForm" style="margin-bottom: 15px;">
                <a-form-model-item label="学生姓名">
                    <a-input class="serach-item" :maxLength="30" allowClear v-model="searchForm.realName"
                             placeholder="请输入学生姓名"/>
                </a-form-model-item>
                <a-form-model-item style="margin-right: 35px;">
                    <a-button @click="getStudentsData(1)" type="primary" html-type="button">
                        查询
                    </a-button>
                </a-form-model-item>
            </a-form-model>
            <a-table :columns="columns"
                     :row-key="text => text.classUserId"
                     :row-selection="tableRowSelection"
                     :pagination="tableRelevant.tablePagination"
                     :dataSource="tableRelevant.tableDataSource">
            </a-table>
            <div style="text-align: center;margin-top: 10px;">
                已选资源：<span class="ant-btn-link">{{this.courseInfo.courseResourceName}}</span>
                已选学生：<span class="ant-btn-link">{{tree.selectStudentNumber}}</span>
                剩余可配：
                <span class="ant-btn-link">
                    {{this.courseInfo.courseResourceIsLimitUser ? tree.surplusStudentNumber < 0 ? "超出剩余可配置数量" : tree.surplusStudentNumber : '不限'}}
                </span>
            </div>
            <div style="text-align: center;margin-top: 20px;">
                <a-button @click="preserveAndOut" type="primary" ghost style="margin-right: 50px;">
                    上一步
                </a-button>
                <a-button @click="preserveAndOut(1)" type="primary">
                    下一步 确认信息
                </a-button>
            </div>
        </div>
    </a-spin>
</template>

<script>
    import { tableRelevant, FormatDate, ArrayUnique2 } from '@/pages/projectImpl/js/utils'

    const columns = [
        { title: '学生', dataIndex: 'realName' },
        { title: '性别', dataIndex: 'genderName' },
        { title: '年级', dataIndex: 'gradeName' },
        { title: '班级', dataIndex: 'className' }
    ]
    export default {
        name: 'StepsSecond',
        data() {
            return {
                organizationId: this.$store.getters["organization/getOrganizationInfo"]().id,
                courseInfo: this.$store.getters["course/getEditCourse"](),
                searchForm: {
                    realName: '',
                    gradeId: undefined,
                    classId: undefined,
                    projectCourseConfigId: this.$store.getters["course/getEditCourse"]().id
                },
                columns,
                //表格相关
                tableRelevant: tableRelevant.call(this),
                //树相关
                tree: {
                    treeData: [],
                    checkedKeys: { //树结构全选与半选
                        checked: [],
                        halfChecked: []
                    },
                    selectedRowKeys: [], // 学生列表选中
                    treeDataChecked: undefined, // 树结构选中状态缓存
                    treeDataValue: {}, // 树结构选中数据缓存
                    selectStudentNumber: 0, //选中学生的数量统计
                    surplusStudentNumber: 0, //剩余学生的数量统计
                    addClassUserIds: [], //新增学生的id
                    deleteClassUserIds: [], //删除学生的id
                }
            }
        },
        computed: {
            tableRowSelection() {
                const that = this
                return {
                    selectedRowKeys: that.tree.selectedRowKeys,
                    /*getCheckboxProps: record => ({
                        props: {
                            disabled: this.courseInfo && this.courseInfo.complete
                        },
                    }),*/
                    onSelect(record, selected) {
                        if (record.hasTested) {
                            that.$message.destroy()
                            that.$message.warn('该用户正在使用课程，不能取消')
                            return
                        }
                        /*if (that.courseInfo.courseResourceIsLimitUser && that.tree.surplusStudentNumber === 0) {
                            that.$message.destroy()
                            that.$message.warn('超出剩余可配置数量')
                            return
                        }*/
                        const indexOf = that.tree.selectedRowKeys.indexOf(record.classUserId)
                        if (selected) {
                            if (indexOf === -1) that.tree.selectedRowKeys.push(record.classUserId)
                        } else {
                            if (indexOf !== -1) that.tree.selectedRowKeys.splice(indexOf, 1)
                        }
                        that.selectTree()
                    },
                    onSelectAll(selected, selectedRows, changeRows) {
                        if (selected) {
                            changeRows.forEach(f => {
                                if (!that.tree.selectedRowKeys.includes(f.classUserId)) {
                                    that.tree.selectedRowKeys.push(f.classUserId)
                                    that.selectTree(f.classId)
                                }
                            })
                        } else {
                            changeRows.forEach(f => {
                                if (f.hasTested) {
                                    return
                                }
                                const indexOf = that.tree.selectedRowKeys.indexOf(f.classUserId)
                                if (indexOf !== -1) {
                                    that.tree.selectedRowKeys.splice(indexOf, 1)
                                    that.selectTree(f.classId)
                                }
                            })
                        }
                    }
                }
            }
        },
        mounted() {
            this.getTreeData()
        },
        methods: {
            //如果是第三步返回，就初始化页面之前选中
            initPageData() {
                if (this.courseInfo.tree) {
                    this.tree = JSON.parse(JSON.stringify(this.courseInfo.tree))
                }
            },
            //获取左侧树结构数据
            getTreeData() {
                const params = {
                    organizationId: this.organizationId,
                    projectCourseConfigIds: this.searchForm.projectCourseConfigId
                }
                this.tableRelevant.tableLoading = true
                this.$http.Course.getGradeDataList(params).then(res => {
                    const {data} = res;
                    this.tree.treeData = data.filter(f => f.level === 1).map(m => {
                        return {
                            ...m,
                            add: [],
                            del: [],
                            //disableCheckbox: this.courseInfo && this.courseInfo.complete,
                            disabled: m.userCount <= 0,
                            scopedSlots: { title: 'title' },
                            children: m.children.map(m1 => {
                                return {
                                    ...m1,
                                    add: [],
                                    del: [],
                                    //disableCheckbox: this.courseInfo && this.courseInfo.complete,
                                    disabled: m1.userCount <= 0,
                                    scopedSlots: { title: 'title' }
                                }
                            })
                        }
                    });
                    try {
                        this.searchForm.gradeId = this.tree.treeData[0].id
                        this.searchForm.classId = this.tree.treeData[0].children[0].id
                    } catch (e) {
                        console.log(e)
                    }
                    this.initPageData();
                    if (this.tree.treeData[0].children[0]){
                        this.getStudentsData('tree', this.tree.treeData[0].children[0])
                    }
                }).finally(() => {
                  this.tableRelevant.tableLoading = false
                })
            },
            //获取右侧学生列表数据
            getStudentsData(checked, json) {
                const params = {
                    organizationId: this.organizationId,
                    pageIndex: 1,
                    pageSize: 99999,
                    ...this.searchForm
                }
                this.tableRelevant.tableLoading = true
                this.$http.Course.getAddCourseStudentList(params).then(res => {
                    const {data} = res;
                    this.tableRelevant.tableDataSource = data.items
                    if (typeof json === "object"){
                        this.tree.treeDataValue = json
                    }
                    this.tableChecked(checked)
                    if (typeof checked === 'boolean') {
                        this.selectTree()
                    } else {
                        this.treeCheckedStyle()
                    }
                }).finally(() => {
                  this.tableRelevant.tableLoading = false
                })
            },
            //树复选框选中或取消
            treeCheck(checkedKeys, e) {
                const value = e.node.dataRef
                if (value.level === 1) { //年级
                    this.searchForm.classId = undefined
                    this.searchForm.gradeId = value.id
                } else {
                    this.searchForm.classId = value.id
                    this.searchForm.gradeId = value.parentId
                }

                this.getStudentsData(e.checked, value)

                //手动添加树结构选中状态
                const li = document.querySelectorAll('.left .ant-tree-node-content-wrapper')
                for (let i = 0; i < li.length; i++) {
                    li[i].classList.remove('ant-tree-node-selected')
                }
                e.node.$el.querySelector('.ant-tree-node-content-wrapper').classList.add('ant-tree-node-selected')
            },


            //页面表格初始化选中
            tableChecked(checked) {
                if (typeof this.tree.treeDataValue !== "object") {
                    return
                }
                if (typeof checked !== 'boolean') {
                    this.tableRelevant.tableDataSource.forEach(f => {
                        if (!(this.tree.treeDataValue.add.length || this.tree.treeDataValue.del.length)) {
                            if (f.hasCheckd && !this.tree.selectedRowKeys.includes(f.classUserId)) {
                                this.tree.selectedRowKeys.push(f.classUserId)
                            }
                        }
                    })
                } else {
                    this.tableRelevant.tableDataSource.forEach(f => {
                        if (!f.hasTested) {
                            const index = this.tree.selectedRowKeys.indexOf(f.classUserId)
                            if (checked) {
                                if (index === -1) this.tree.selectedRowKeys.push(f.classUserId)
                            } else {
                                if (index !== -1) this.tree.selectedRowKeys.splice(index, 1)
                            }
                        }
                        if (f.hasTested && !this.tree.selectedRowKeys.includes(f.classUserId)) {
                            this.tree.selectedRowKeys.push(f.classUserId)
                        }
                    })
                }
            },

            //树结构全选和半选
            treeCheckedStyle() {
                /**
                 * 设置树结构全选半选样式
                 * @param data
                 */
                const setTreeStyle = (data) => {
                    const checked = this.tree.checkedKeys.checked.indexOf(data.id)
                    const halfChecked = this.tree.checkedKeys.halfChecked.indexOf(data.id)
                    const selectNumber = data.selectStuNum + data.add.length - data.del.length

                    if (data.userCount === selectNumber && selectNumber > 0) {
                        if (checked === -1) {
                            this.tree.checkedKeys.checked.push(data.id)
                            if (halfChecked > -1) {
                                this.tree.checkedKeys.halfChecked.splice(halfChecked, 1)
                            }
                        }
                    } else if (selectNumber > 0 && data.userCount > selectNumber) {
                        if (halfChecked === -1) {
                            this.tree.checkedKeys.halfChecked.push(data.id)
                            if (checked > -1) {
                                this.tree.checkedKeys.checked.splice(checked, 1)
                            }
                        }
                    } else {
                        if (checked > -1) {
                            this.tree.checkedKeys.checked.splice(checked, 1)
                        }
                        if (halfChecked > -1) {
                            this.tree.checkedKeys.halfChecked.splice(halfChecked, 1)
                        }
                    }
                };
                let selectUserIdsLength = 0;
                this.tree.selectStudentNumber = 0;
                this.tree.treeData.forEach(f => {
                    if (f.children && f.children.length) {
                        let add = [], del = []
                        f.children.forEach(f1 => {
                            add = add.concat(f1.add)
                            del = del.concat(f1.del)
                            setTreeStyle(f1)
                        })
                        f.add = add
                        f.del = del
                        setTreeStyle(f)
                    }
                    const num = ArrayUnique2(f.add.map(m => m.split(",")[0])).length - ArrayUnique2(f.del.map(m => m.split(",")[0])).length;
                    selectUserIdsLength += num;
                    //选中学生数量统计
                    this.tree.selectStudentNumber += f.userIds.length + num
                    //剩余学生数量统计
                })
                if (this.courseInfo.courseResourceIsLimitUser) {
                    /*this.tree.surplusStudentNumber = this.courseInfo.courseResourceMaxUserCount
                        - this.courseInfo.courseResourceConfigUserCount - this.tree.selectStudentNumber*/
                    this.tree.surplusStudentNumber = this.courseInfo.courseResourceMaxUserCount
                        - this.courseInfo.courseResourceConfigUserCount - selectUserIdsLength
                }
            },


            /**
             * 树结构选中及学生选中数量监听
             * @param id 可选  班级的id
             */
            selectTree(id) {
                //树复选框新增或删除了哪些学生
                const treeAddOrDelStudent = (data) => {
                    this.tableRelevant.tableDataSource.forEach(item => {
                        if (data.id === item.classId) {
                            const addIndex = data.add.indexOf(item.organizationUserId + "," + item.classUserId);
                            const delIndex = data.del.indexOf(item.organizationUserId + "," + item.classUserId);
                            if (this.tree.selectedRowKeys.includes(item.classUserId)) {
                                if (!item.hasCheckd) {
                                    if (addIndex === -1) data.add.push(item.organizationUserId + "," + item.classUserId)
                                } else {
                                    if (delIndex !== -1) data.del.splice(delIndex, 1)
                                }
                            } else {
                                if (!item.hasCheckd) {
                                    if (addIndex !== -1) data.add.splice(addIndex, 1)
                                } else {
                                    if (delIndex === -1) data.del.push(item.organizationUserId + "," + item.classUserId)
                                }
                            }
                        }
                    })
                }

                let json = this.tree.treeDataValue

                if (id) {
                    this.tree.treeData.forEach(f => {
                        if (f.children && f.children.length) {
                            for (let i = 0; i < f.children.length; i++) {
                                if (id === f.children[i].id) {
                                    json = f.children[i]
                                }
                            }
                        }
                    })
                }

                if (json.level === 1) {
                    if (json.children && json.children.length) {
                        json.children.forEach(f => {
                            treeAddOrDelStudent(f)
                        })
                    }
                } else {
                    treeAddOrDelStudent(json)
                }

                this.treeCheckedStyle()
            },

            //下一步或上一步
            preserveAndOut(val) {
                this.$message.destroy();
                if (val === 1) {
                    if (this.tree.surplusStudentNumber < 0){
                        this.$message.warning("超出剩余可配置数量");
                        return
                    }
                    this.tree.addClassUserIds = []
                    this.tree.deleteClassUserIds = []
                    this.tree.treeData.forEach(f => {
                        this.tree.addClassUserIds = this.tree.addClassUserIds.concat(f.add)
                        this.tree.deleteClassUserIds = this.tree.deleteClassUserIds.concat(f.del)
                    })
                    let json = {
                        ...this.courseInfo,
                        tree: this.tree
                    }
                    this.$store.commit('course/setEditCourse', json)
                    this.$emit('steps', 2)
                } else {
                    this.$emit('steps', 0)
                }
            }
        }
    }
</script>

<style scoped>
    #StepsSecond, #StepsSecond >>> .ant-spin-container {
        height: 100%;
    }

    .hideScroll {
        height: 100%;
        overflow-y: auto;
        scrollbar-width: none; /* firefox */
        -ms-overflow-style: none; /* IE 10+ */
    }

    .hideScroll::-webkit-scrollbar {
        display: none; /* Chrome Safari */
    }

    #StepsSecond >>> > .ant-spin-container {
        display: flex;
    }

    #StepsSecond .left {
        width: 260px;
        flex-shrink: 0;
        margin-right: 20px;
        border-right: 1px solid #ddd;
    }

    #StepsSecond .right {
        flex-grow: 1;
    }

    .ant-btn-link {
        margin-right: 15px;
    }

    .disabled {
        pointer-events: none;
    }
</style>
